import { assert_string_object_id, assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__generation_start extends DTO__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION_START;

  /*
   * FIELDS
   */
  generation_id!: string;
  ml_asset_reservation_id!: string;

  /*
   * METHODS
   */

  constructor() {
    super();
  }

  assert_standard_fields(): void {
    assert_string_object_id_not_empty(this.generation_id);
    assert_string_object_id(this.ml_asset_reservation_id);
  }
}
